// Module
var code = `<h2 class="modal-title"> {{ modalTitleController.model.id !== undefined ? modalTitleController.editTitle : modalTitleController.createTitle }} </h2> `;
// Exports
module.exports = code;